﻿interface Utilities {
    getElementClientWidth(selector: string): Promise<number | null>;
}

const utilities: Utilities = {
    async getElementClientWidth(selector: string): Promise<number | null> {
        const el = document.querySelector(selector);
        return el ? el.clientWidth : null;
    }
};

(window as any).utilities = utilities;